export const SET_NOTES = "SET_NOTES";
export const ADD_NOTE = "ADD_NOTE";
export const UPDATE_NOTE = "UPDATE_NOTE";
export const REMOVE_NOTE = "REMOVE_NOTE";

export const SET_LOADING = "SET_LOADING";
export const SET_ERROR = "SET_ERROR";

export const SET_NOTE_WINDOW_SIZE = "SET_NOTE_WINDOW_SIZE";
export const UPDATE_NOTE_WINDOW_SIZE_REQUEST =
  "UPDATE_NOTE_WINDOW_SIZE_REQUEST";
export const UPDATE_NOTE_WINDOW_SIZE_SUCCESS =
  "UPDATE_NOTE_WINDOW_SIZE_SUCCESS";
export const UPDATE_NOTE_WINDOW_SIZE_FAILURE =
  "UPDATE_NOTE_WINDOW_SIZE_FAILURE";
